// extracted by mini-css-extract-plugin
export var content = "footer-module--content--ZRN9H";
export var link = "footer-module--link--viPhc";
export var logo = "footer-module--logo--4RKe2";